var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ '--slide-down-duration': (_vm.duration + "ms") })},[_c('transition',{attrs:{"name":"slide-down"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }